import { labels } from './labels.js';

export var store = {
  state: {  
    storeSettings: [],
    settings: {
        langId: Cookies.get('marketplace-lang'),
        customerId: 0,
        cartId: Cookies.get('marketplace-cart')
    },
    status: {
        isLoading: true,
        isRemovingCarts: false,
        showAdjustments: false
    },
    carts: [],
    cartsStatus: [],
    subTotal: 0,
    quantity: 0,
    keys: labels,
    customerKeys: [],
    customerLabels: [],
    attributesGroups: [],
    labels: []
  },
  getLabels: function () {
      return $.ajax({
          url: '/api/APIStore/GetLabels',
          type: 'GET',
          data: {
              langId: store.state.settings.langId,
              keys: store.state.keys
          }
      })
          .done((data) => {
              store.state.labels = data;
          })
  },
  getLabel: function (key) {
    var index = _.findIndex(store.state.labels, function (o) {
      return o.Key == key;
    });

    if (index == -1) {
      return "";
    }

    return store.state.labels[index].Value;
  },
  getCustomerKeys: function () {
    var self = this;

    var keys = [];
    _.each(self.state.carts, function (c) {
      if (c.Attributes && c.Attributes != null) {
        _.each(c.Attributes, function (a) {

          if (a.ProductAttributeGroup != null && a.ProductAttributeGroup != undefined) {
            keys.push(a.ProductAttributeGroup.Label);
          }

          keys.push(a.Label);
        })
      }
    });

    self.state.customerKeys = keys;
  },
  getCustomerLabels: function () {

    var keys = store.state.customerKeys.map(function (o) {
      return encodeURIComponent(o);
    })

    var labelsRequest = {
      langId: store.state.settings.langId,
      keys: keys
    };

    return $.ajax({
      url: '/api/APIStore/GetCustomerLabels',
      type: 'POST',
      contentType: "application/json; charset=utf-8",
      dataType: 'json',
      data: JSON.stringify(labelsRequest)
    })
    .done(function (data) {

      store.state.customerLabels = data.map(function (o) {
        o.Key = decodeURIComponent(o.Key);
        o.Value = decodeURIComponent(o.Value);

        return o;
      });
    })
  },  
  getCustomerLabel: function (key) {
    var index = _.findIndex(store.state.customerLabels, function (o) {
      return o.Key == key;
    });

    if (index == -1) {
      return "";
    }

    return store.state.customerLabels[index].Value;
  },
  getAttributesGroups: function () {
    var self = this;
    var groups = [];

    _.forEach(self.state.carts, function (c) {
      _.forEach(c.Attributes, function (a) {
        if (a.ProductAttributeGroup != null && a.ProductAttributeGroup != undefined) {

          var index = _.findIndex(groups, function (g) {
            return g.Id == a.ProductAttributeGroup.Id;
          })

          if (index == -1) {
            groups.push(a.ProductAttributeGroup);
          }
        }
      });
    });    

    groups = _.uniqBy(groups, function (o) {
      return o.Id;
    });

    groups = _.sortBy(groups, function (o) {
      return o.Sequence;
    });

    self.state.attributesGroups = groups;
  },
  getAttributeGroups: function (cart) {
    var self = this;
    var groups = [];

    _.forEach(self.state.attributesGroups, function (ag) {
      var index = _.findIndex(cart.Attributes, function (a) {
        return a.ProductAttributeGroupId == ag.Id;
      })

      if (index != -1) {
        groups.push(ag);
      }

    });

    groups = _.sortBy(groups, function (o) {
      return o.Sequence;
    });

    return groups;
  },
  getSettings: function () {
      return $.ajax({
          url: '/api/APIStore/GetSettings',
          type: 'GET'
      })
          .done(function (data) {
              Object.assign(store.state.settings, data);
              store.state.settings.customerId = store.state.settings.CustomerId;
          })
  },
  getStoreSettings: function () {
      return $.ajax({
          url: '/api/APIStoreSettings/GetStoreSettings',
          type: 'GET'
      })
          .done(function (data) {                
              store.state.storeSettings = data;
          })
  },
  getCarts: function () {
      return $.ajax({
          url: '/api/apicart/getcarts',
          type: 'GET'
      })
          .done(function (data) {

              data.Carts.map(function (cart, index) {
                  cart.IsUpdating = false;
                  cart.IsRemoving = false;
              });

              store.state.carts = data.Carts;
              store.state.cartsStatus = data.Status;
          })
          .fail(function () {
              // Show Error Message
              toastr["error"](store.getLabel('_webservererror'));
          })
  },
  getSubTotal: function () {
      return $.ajax({
          url: '/api/apicart/getsubtotal',
          type: 'GET'
      })
          .done(function (data) {
              store.state.subTotal = data;
          })
          .fail(function () {
              // Show Error Message
              toastr["error"](store.getLabel('_webservererror'));
          })
  },
  getQty: function () {
      return $.ajax({
          url: '/api/apicart/getcartqty',
          type: 'GET'
      })
          .done(function (data) {
              store.state.quantity = data;
              UpdateCart();
          })
          .fail(function () {
              // Show Error Message
              toastr["error"](store.getLabel('_webservererror'));
          })
  },
  updateCart: function (cart) {

      cart.IsUpdating = true;

      return $.ajax({
          url: '/api/apicart/updateqty',
          type: 'POST',
          data: JSON.stringify(cart),
          contentType: "application/json; charset=utf-8",
          dataType: 'json'
      })
          .done(function (data) {
              // Get cart and update qty in the ux
              var index = _.findIndex(store.state.carts, function (o) {
                  return o.Id == data.Id;
              });

              $.when(store.getCarts(), store.getSubTotal(), store.getQty()).done(function () {                    
                  // Function on site.js to update the cart
                  UpdateCart();
                  toastr["success"](data);
              })
          })
          .fail(function () {
              // Show Error Message
              toastr["error"](store.getLabel('_webservererror'));
          })
          .always(function () {
              cart.IsUpdating = false;
              UpdateCart();
          })
  },
  removeCart: function (cart) {
      var self = this;
      var index = _.findIndex(store.state.carts, function (o) {
          return o.Id == cart.Id;
      });

      store.state.carts[index].IsRemoving = true;

      return $.ajax({
          url: '/api/apicart/removecart',
          type: 'POST',
          data: JSON.stringify(cart),
          contentType: "application/json; charset=utf-8",
          dataType: 'json'
      })
          .done(function (data) {
              store.state.carts[index].IsRemoving = false;
              store.state.carts.splice(index, 1);
              // Function on site.js to update the cart
              self.getCarts();
              self.getQty();
              self.getSubTotal();
                
              toastr["success"](store.getLabel('_done'));
          })
          .fail(function () {
              // Show Error Message
              store.state.carts[index].IsRemoving = false;
              toastr["error"](store.getLabel('_webservererror'));
          })
          .always(function () {
              UpdateCart();
          })
  },
  removeCarts: function () {
      var self = this;
      self.state.status.isRemovingCarts = true;
      return $.ajax({
          url: '/api/apicart/RemoveCarts',
          type: 'POST',            
          contentType: "application/json; charset=utf-8",
          dataType: 'json'
      })
          .done(function (data) {
              self.state.carts = [];                
          })
          .fail(function () {
              // Show Error Message                
              toastr["error"](store.getLabel('_webservererror'));
          })
          .always(function () {
              self.state.status.isRemovingCarts = false;
              UpdateCart();
          })        
  },
  toggleMessages: function () {
      this.state.status.showAdjustments = !this.state.status.showAdjustments;
  },
  init: function () {
                
      store.state.status.isLoading = true;

      $.when(
          store.getLabels(),
          store.getSettings(),
          store.getStoreSettings()
      )
      .done(function () {
        $.when(                    
          store.getCarts()
        )
        .done(function () {
          $.when(
            store.getAttributesGroups(),
            store.getCustomerKeys(),
            store.getCustomerLabels(),
            store.getSubTotal(),
            store.getQty()
          ).done(function () {
              store.state.status.isLoading = false;
          })
          .fail(function () {
              store.state.status.isLoading = false;
          });
        })
        .fail(function () {
          store.state.status.isLoading = false;
        });
      })
      .fail(function () {
        store.state.status.isLoading = false;
      });
  }
};